import { WithOwnerId } from '@mews-commander/types';
import { useResolveRoute } from '@mews/routing';
import { RouteName, TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { ModalWrapper, NewModalBodyWrapper } from '@mews-commander/ui';
import { useEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { Breadcrumbs } from '../../components';
import ModalHeader from '../../legacy/React/Components/Common/ModalHeader';
import { DigitalKeyConfiguration } from './components/DigitalKeyConfiguration';

export const DigitalKeyConfigurationContainer = ({ ownerId: enterpriseId }: WithOwnerId) => {
    const { name: enterpriseName } = useEnterprise(enterpriseId);

    const resolveRoute = useResolveRoute();
    const enterpriseUrl = resolveRoute(RouteName.EnterpriseDetail, { enterpriseId });

    const breadcrumbs: Breadcrumbs = [
        { text: enterpriseName, url: enterpriseUrl },
        {
            text: <LocalizedText textKey={TextKey.DigitalKey} />,
            active: true,
        },
    ];

    return (
        <ModalWrapper>
            <ModalHeader breadcrumbs={breadcrumbs} />
            <NewModalBodyWrapper padded>
                <DigitalKeyConfiguration />
            </NewModalBodyWrapper>
        </ModalWrapper>
    );
};
